import { AdChannel, Ad, AdStatus } from 'types/adTypes';

export const filterAdsByChannels = (channels: AdChannel[], ads: Ad[]) => {
  return ads.filter((ad) => ad.channel && channels.includes(ad.channel));
};

export const statusToInt = (status: AdStatus): number => {
  return status === 'ACTIVE' ? 1 : 0;
};
